import { createFileRoute } from "@tanstack/react-router";
import SitioWebSolucion from "../../pages/soluciones/SitioWeb";

export const Route = createFileRoute("/que-hacemos/sitio-web")({
  component: SitioWebSolucion,
});
